import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_image = _resolveComponent("a-image");
  return _openBlock(), _createBlock(_component_a_image, {
    style: {
      "max-width": "100%",
      "max-height": "800px"
    },
    src: _ctx.srcRef,
    alt: _ctx.alt,
    preview: _ctx.preview
  }, null, 8, ["src", "alt", "preview"]);
}